import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const StyledRow = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  gap: 1em;
  flex-direction: row;
  overflow-x: scroll;
  white-space: nowrap;
  align-items: center;
  overflow: auto;
`

export const StyledMenuButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
`

export const iconSize = '36px'

export const StyledMenuIconItem = styled.img`
  display: block;
  height: ${iconSize};
  width: ${iconSize};
  box-sizing: border-box;
  padding: 6px;

  border-radius: 20px;

  outline: none;
  color: transparent;
  cursor: pointer;

  background-color: ${themeStyles.colors.darkGreys[4].main};
`
